export var createGetBackupOfflineAudioContext = function createGetBackupOfflineAudioContext(backupOfflineAudioContextStore) {
  return function (nativeContext) {
    return backupOfflineAudioContextStore.get(nativeContext);
  };
};